import { render } from "./ViDeo.vue?vue&type=template&id=02a4140c&scoped=true&ts=true"
import script from "./ViDeo.vue?vue&type=script&lang=ts"
export * from "./ViDeo.vue?vue&type=script&lang=ts"

import "./ViDeo.vue?vue&type=style&index=0&id=02a4140c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a4140c"]])

export default __exports__